class ProductInfoTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = [];
    this.panels = [];
    this.selectedIndex = 0;
    this.anchorIds = [];
    this.scrollOnTabClick = [];
    this.lastContentIndex = -1;
  }

  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.anchorIds = this.buttons.map((btn) => btn.dataset.scrollTarget || '');
    this.scrollOnTabClick = this.buttons.map((btn) => btn.dataset.scrollOnTabClick !== 'false');

    this.buttons.forEach((btn, i) => {
      btn.addEventListener('click', (e) => this.onTabClick(e, i));
    });

    this.addEventListener('click', this.onScrollLinkClick);

    this.initSelection();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onScrollLinkClick);
  }

  onScrollLinkClick = (e) => {
    const btn = e.target.closest('[data-product-info-tabs-scroll]');
    if (!btn || !this.contains(btn)) return;
    e.preventDefault();
    const id = btn.getAttribute('data-product-info-tabs-scroll');
    if (id) this.scrollToId(id);
  };

  getScrollExtra() {
    const raw = this.dataset.scrollOffset;
    const base = raw ? parseInt(raw, 10) : 20;
    let header = 0;
    const headerEl = document.querySelector('[data-sticky-header]');
    if (headerEl) {
      const h = Math.round(headerEl.offsetHeight);
      if (headerEl.isAlwaysSticky) {
        header = h;
      } else {
        const pinnedClass = headerEl.classes && headerEl.classes.pinned;
        const pinned = pinnedClass ? document.body.classList.contains(pinnedClass) : false;
        if (pinned || window.scrollY > this.offsetTop - base) {
          header = h;
        }
      }
    }
    return base + header;
  }

  scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    const offset = this.getScrollExtra();
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  isScrollOnlyTab(i) {
    return !!(this.anchorIds[i] && this.scrollOnTabClick[i]);
  }

  initSelection() {
    const firstContent = this.buttons.findIndex((_, i) => !this.isScrollOnlyTab(i));
    const start = firstContent >= 0 ? firstContent : 0;
    this.lastContentIndex = firstContent;
    this.applySelection(start);
  }

  onTabClick(e, index) {
    e.preventDefault();
    if (this.isScrollOnlyTab(index)) {
      this.scrollToId(this.anchorIds[index]);
      this.setTabVisual(index);
      this.updatePanels();
      return;
    }
    this.applySelection(index);
  }

  setTabVisual(activeIndex) {
    this.selectedIndex = activeIndex;
    this.buttons.forEach((btn, i) => {
      const on = i === activeIndex;
      btn.classList.toggle('product-info-tabs__tab--active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  updatePanels() {
    const sel = this.selectedIndex;
    const showIdx = this.isScrollOnlyTab(sel) ? this.lastContentIndex : sel;
    this.panels.forEach((panel, i) => {
      panel.hidden = showIdx < 0 || i !== showIdx;
    });
  }

  applySelection(index) {
    this.setTabVisual(index);
    if (!this.isScrollOnlyTab(index)) {
      this.lastContentIndex = index;
    }
    this.updatePanels();
  }
}

if (!customElements.get('product-info-tabs')) {
  customElements.define('product-info-tabs', ProductInfoTabs);
}
